import React from "react";
import PropTypes from "prop-types";


export var Avatar = (props) => {
    return props.hasProfile && <div className="avatarRow">
            <div className="avatar" style={{backgroundImage: `url(${props.avatarUrl})`}}></div>
            <label htmlFor="avatarUpload"><i className="ion-android-camera"/></label>
            <input type="file" id="avatarUpload" name="avatar" onChange={props.handleUpload} accept="image/*" style={{display:"none"}}/>
        </div>
}

Avatar.PropTypes = {
    avatarUrl: PropTypes.string.isRequired,
    handleUpload: PropTypes.func,
    hasProfile: PropTypes.bool.isRequired
}

export default Avatar;